import React from "react";
import Navbar from "../components/Navbar";
import { Hero } from "../components/Hero";
import Content from "../components/Content";
import Footer from "../components/Footer";

function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <Content />
      <Footer />
    </>
  );
}

export default Home;
